import {Message} from 'element-ui'
import api from '@/fetch/api'
import storage from '@/fetch/storage'
import {getTenantLoginPath} from '@/utils/tenantLogin'

const LICENSE_VALID = 0
const CHECK_INTERVAL = 30000

let timer = null
let checking = false
let routerRef = null

function isLoginPage() {
  return routerRef && routerRef.currentRoute && routerRef.currentRoute.path.includes('/login')
}

function shouldCheck() {
  return Boolean(routerRef && storage.get('token') && !isLoginPage())
}

function stopTimer() {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
}

function redirectToLogin(message) {
  if (!storage.get('token')) return
  storage.remove('token')
  Message.warning(message || '系统授权已失效，请重新登录')
  if (!isLoginPage()) {
    routerRef.replace({path: getTenantLoginPath(routerRef.currentRoute)}).catch(() => {})
  }
  stopTimer()
}

function getErrorMessage(error) {
  return (error && error.data && error.data.msg)
    || (error && error.response && error.response.data && error.response.data.msg)
    || (error && error.message)
    || ''
}

function checkLicense() {
  if (checking || !shouldCheck()) return
  checking = true
  api.licenseStatus().then(res => {
    const status = res && res.data
    if (!status || status.status !== LICENSE_VALID) {
      redirectToLogin((status && status.message) || '系统授权已失效，请重新登录')
    }
  }).catch(error => {
    const message = getErrorMessage(error)
    if (message.includes('授权') || message.toLowerCase().includes('license')) {
      redirectToLogin(message)
    }
  }).finally(() => {
    checking = false
  })
}

function ensureTimer() {
  if (!shouldCheck()) {
    stopTimer()
    return
  }
  if (!timer) {
    timer = setInterval(checkLicense, CHECK_INTERVAL)
  }
}

export function startLicenseWatcher(router) {
  routerRef = router
  router.afterEach(() => {
    ensureTimer()
    setTimeout(checkLicense, 0)
  })
  ensureTimer()
  setTimeout(checkLicense, 0)
}
